import * as React from 'react';
import { useTranslation } from 'next-i18next';
import { LinkIcon } from '@heroicons/react/24/outline';
import { useAtomValue } from 'jotai';
import Link from 'next/link';

import { restaurantDetailsAtom, ShowcaseSectionTitle } from '.';
import { Button as ButtonV2 } from '@restworld/ui-ds-base';

const websiteLabel = {
  website_url: 'Website',
  facebook_url: 'Facebook',
  instagram_url: 'Instagram',
  twitter_url: 'Twitter',
  youtube_url: 'YouTube',
  tiktok_url: 'TikTok',
  whatsapp_url: 'WhatsApp',
  telegram_url: 'Telegram',
  linkedin_url: 'LinkedIn',
  the_fork_url: 'TheFork',
  tripadvisor_url: 'TripAdvisor',
  other_social_media_url: 'Other Social Media',
};
const isURLValid = (url: string) => {
  const urlRegex = /^(https?:\/\/)?([\w-]+(\.[\w-]+)+)(\/[\w- ./?%&=]*)?$/i;
  // Check if the URL matches the regex pattern
  return urlRegex.test(url);
};
// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface IVenueLinksProps {}

const VenueLinks: React.FunctionComponent<IVenueLinksProps> = (props) => {
  const { t } = useTranslation('restaurant-showcase-v2');
  const restaurantDetails = useAtomValue(restaurantDetailsAtom);
  const socialLinks = React.useMemo(() => restaurantDetails?.socialMediaUrl, [restaurantDetails]);

  const linksList = React.useMemo(
    () =>
      Object.entries(socialLinks || {}).map(([key, url]) =>
        url && isURLValid(url) ? (
          <Link href={url} target="_blank" rel="noopener noreferrer" className="w-full" key={key}>
            <ButtonV2 key={key} variant="secondary-neutral" fullwidth EndIcon={LinkIcon}>
              {websiteLabel[key] || key.replace(/_/g, '').replace(/\b\w/g, (l) => l.toUpperCase())}
            </ButtonV2>
          </Link>
        ) : null
      ),
    [socialLinks]
  );
  return (
    socialLinks &&
    Object.keys(socialLinks)?.length > 0 && (
      <div className="self-stretch inline-flex flex-col justify-start items-start gap-4">
        <ShowcaseSectionTitle title={t('social_links')} />
        <div className="self-stretch flex flex-col justify-start items-start gap-4">{linksList}</div>
      </div>
    )
  );
};

export default VenueLinks;
